import { render, staticRenderFns } from "./KategoriBerita.vue?vue&type=template&id=ffcb27b4&scoped=true"
import script from "./KategoriBerita.vue?vue&type=script&lang=js"
export * from "./KategoriBerita.vue?vue&type=script&lang=js"
import style0 from "./KategoriBerita.vue?vue&type=style&index=0&id=ffcb27b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcb27b4",
  null
  
)

export default component.exports